import React from 'react';
import styled from 'styled-components';
import { Tabs, Tab } from '@material-ui/core';
import { Paper } from '@material-ui/core';

export const StyledTabs = styled((props) => {
  return (
    <Tabs
      {...props}
      classes={{ indicator: 'indicator' }}
      TabIndicatorProps={{ children: <span /> }}
    />
  );
})`
  && .MuiTab-root {
    min-width: 90px;
  }
  && {
    background-color: transparent;
  }
  && .indicator {
    display: flex;
    justify-content: center;
    background-color: transparent;
    height: 4px;
    > span {
      width: 80%;
      background-color: #f9ac19;
      border-radius: 1.5px;
      margin-top: 1px;
    }
  }
`;
/* istanbul ignore next */
export const StyledTabsRes = styled((props) => {
  return (
    <Tabs
      orientation="vertical"
      {...props}
      classes={{ indicator: 'indicator' }}
      TabIndicatorProps={{ children: <span /> }}
    />
  );
})`
  && .MuiTab-root {
    min-width: 90px;
    display: inline-grid;
  }
  && {
    background-color: transparent;
  }
  && .indicator {
    display: flex;
    justify-content: center;
    background-color: transparent;
    height: 4px;
  }
`;

export const StyledTab = styled(Tab)`
  && {
    width: 100px;
    color: #ffffff !important;
    font-size: 15px !important;
    font-weight: 500;
    line-height: 17px;
    text-transform: none;
    text-align: left !important;
    opacity: 2 !important;
    &:focus {
      color: #ffffff !important;
      font-weight: 500;
    }
    &&.Mui-selected {
      color: #ffffff;
      font-weight: 500;
    }
  }
`;

export const StyledPaper = styled(Paper)`
  && {
    padding: 14px;
    height: auto;
    width: 100px;
    justify-content: center;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);
  }
`;
